module.exports = __webpack_public_path__ + "static/media/sp-reservation-title-moving@2x.cf9f1637.png";